import type { QueryKey } from '@tanstack/react-query';
import {
  ColumnDataTypes,
  FilterOptionTypes,
  type ColumnDataType,
  type DynamicFilterOptions,
  type DynamicFilterOptionsPage,
  type FilterOperatorObject,
  type FilterOptionsParams,
} from '@/components/DataTable';
import { EndpointOperators } from './operators';

/**
 * KIR-5098: the endpoint name-or-ID column filter, shared so every page gets
 * the same operators, input and Matches list.
 */
export function endpointFilterConfig({
  getQueryKey,
  queryFn,
}: {
  getQueryKey: (params: FilterOptionsParams) => QueryKey;
  queryFn: (params: FilterOptionsParams) => Promise<DynamicFilterOptionsPage>;
}): {
  filterable: true;
  dataType: ColumnDataType;
  filterOperators: FilterOperatorObject[];
  filterOptions: DynamicFilterOptions;
} {
  return {
    filterable: true,
    dataType: ColumnDataTypes.STRING,
    filterOperators: EndpointOperators,
    filterOptions: {
      type: FilterOptionTypes.DYNAMIC,
      getQueryKey,
      queryFn,
      pagination: { mode: 'offset', limit: 10 },
      queryConfig: { staleTime: 60 * 1000 },
      suggestInput: {
        label: 'Endpoint name or ID',
        placeholder: 'Name or ID',
      },
    },
  };
}
